import { FormContainerStyle, HeaderLogin, LoginImage } from "./loginPageStyle";
import { Grid } from "@mui/material";
import loginImage from "../../assets/login/login.jpg";
import LoginForm from "../../components/Login/LoginForm";
import { useState } from "react";
import SignUpForm from "../../components/SignUp/SignUpForm";

const LoginPage = () => {
  const [isLogin, setIsLogin] = useState(false);

  return (
    <HeaderLogin>
      <Grid container spacing={10}>
        <Grid item md={6} xs={12}>
          <FormContainerStyle>
            {!isLogin ? (
              <LoginForm setIsLogin={setIsLogin} />
            ) : (
              <SignUpForm setIsLogin={setIsLogin} />
            )}
          </FormContainerStyle>
        </Grid>
        <Grid item md={6} xs={12} sx={{ display: { md: "flex", xs: "none" } }}>
          <LoginImage>
            <img src={loginImage} alt="login" />
          </LoginImage>
        </Grid>
      </Grid>
    </HeaderLogin>
  );
};

export default LoginPage;
